/**
 * PersonelDetayPage.jsx — Personel Belgeleri İncele'nin (`PersonelIncelemePage.jsx`) detay
 * sayfası. Route: /Management/Firmalar/Personel/:firmaId/:personId
 *
 * Liste sayfasındaki her kart yalnızca özet (ad, rozetler, sayaçlar) gösterip "Detaylar"a
 * tıklandığında buraya yönlendiriyor. Firma-tarafı FirmaPersonelListPage.jsx/
 * FirmaPersonelDetailPage.jsx ile aynı liste+detay ayrımı, inceleme/admin tarafının
 * karşılığı. Mock katmanı YOK — canlı yerel backend'e karşı doğrudan kuruldu.
 *
 * Servisler: personnelAdminService.js (kadro + belge onay/red) ve kisiAdminService.js
 * (kimlik doğrulama, meslek, KVKK durumu, Özel İzin, ekstra alanlar).
 * Rehberler: docs/guides/FE-PersonnelController-guide.md ve
 *            docs/guides/FE-PersonnelController-kimlik-meslek-guide.md
 *
 * ── 2026-08-29 revizyonu: giriş kuralı 2026-08-28'de değişti, sayfa yeniden kuruldu ──
 *
 * ESKİ kural: KVKK + (firma muafiyeti VEYA kişisel dörtlü).
 * YENİ kural: KVKK VE ( (firma üçlüsü VE MESLEĞİN istediği belgeler VE — fuar istiyorsa —
 *             kimlik doğrulama) VEYA Özel İzin ).
 *   2026-09-17 (backend #54): "fuar istiyorsa" kalktı — kimlik doğrulama artık HER fuarda
 *   zorunlu (Özel İzin hâlâ kaldırır). Bkz. Kimlik Doğrulama kartındaki "Kart için zorunlu".
 *   2026-10-19 (backend #474 / #475): Özel İzin artık KİMLİK DOĞRULAMANIN yerine geçmez — kart kararı
 *   KVKK VE kimlik VE ( belgeler VEYA Özel İzin ); doğrulanmamış kişiye yeni izin verilmez (409).
 *
 * Üç sonucu doğrudan bu sayfanın şeklini belirledi:
 *  1. **`muaf` artık kimseyi muaf tutmuyor.** Ad yanıltıcı ama geriye dönük uyumluluk için
 *     duruyor; sayfa `firmaBelgeleriTamam`ı okuyor ve rozeti "Firma İSG Belgeleri Tamam" diye
 *     etiketliyor (#140: üçlü İSG grubudur). Eski "Muaf" mavi rozeti kaldırıldı — yanlış bilgi veriyordu.
 *  2. **Uygunluk artık istemcide TÜRETİLMİYOR.** Backend `uygunsuzluklar[]` döndürüyor;
 *     sayfa onu olduğu gibi listeliyor. Kuralı iki yerde tutmanın maliyeti, 2026-08-28'de
 *     tam olarak bu sayfanın yanlış "Kart Alabilir" göstermesiydi.
 *  3. **Belge listesi sabit beşli değil.** `gerekliBelgeler` mesleğe göre değişir (daha
 *     KISA da olabilir); `documents{}` gereksiz belgeleri de taşır. Sayfa ikisini ayırıyor:
 *     "İstenen belgeler" ve "Diğer yüklenmiş belgeler".
 *
 * 🚨 Özel İzin kartı bilinçli olarak inceleme tarafında ve UYARILI: backend'de bu uçta
 * staff kontrolü YOK, yani firma hesabı da kendi kadrosuna verebilir (rehberde Deniz'e
 * bildirilmiş açık). Firma tarafında buna karşılık gelen bir buton YAPILMADI.
 *
 * Backlog #142/#145/#250 (2026-10-02): SGK/İSG kutuları dolduran varyantı (İşe Giriş Bildirgesi / Hizmet
 * Dökümü …) yazar ve Yükle ile BelgeVaryantModal'ı açar. Paylaşımlı belge (96/98) dosya başına değil
 * ÇALIŞAN başına incelenir: inceleme penceresi `paylasimliBelgeId` doluysa `.../paylasimli-belgeler/{id}/karar`
 * çağırır (dosya ucu 400 verir). Paylaşımlı olmayan her belgede Taşı / Havuza al (BelgeTasimaModal), kutuda
 * "taşındı" notu, belgelerin altında Havuz kartı (KisiHavuzKarti). Bkz. util/knowledgebase/paylasimli-belgeler-ve-tasima.md.
 *
 * Backlog #137/#138 (2026-10-02): sayfa dört sekmeye bölündü — Belgeler (varsayılan; en üstte kare+sayaç özeti),
 * Meslek, Kimlik Doğrulama, Detaylar (KVKK + Özel İzin + Ek Bilgiler). Sekme `?tab=` ile tutulur; liste sayfasının
 * gönderdiği `?belge=<anahtar>` artık dinleniyor (açılışta o belgenin inceleme penceresi açılır).
 * Sayfadaki uyarı metinleri kırpıldı AMA bilgi taşıyanlar kaldı: Özel İzin'in "KVKK dışında hiçbir belge
 * istenmez" cümlesi ve Kimlik'teki "Kart için zorunlu" rozeti (#54). Silinen açıklamaların gerekçesi burada:
 *  · KVKK'nın ÜÇ bağımsız kaynağı var (giriş kuralı hangisini bulursa karşılanır): onaylı KVKK BELGESİ
 *    (file_type 56), `person_kvkk_status_id = 3` (ıslak imzalı asıl teslim) ve kişinin DİJİTAL onayı
 *    (`kvkkDijitalOnay.tamam`, #139). Durum 1 saklanır ama etkisizdir (11.344 kayıtta var, belgeyle
 *    uyuşmuyor). Kart bu üçünü AYRI satırlarda ve AYRI düğmelerle gösterir; "KVKK" diye tek bir
 *    kontrol hangisine dokunduğunu gizler ve alanlar birbirinden uzaklaşır.
 *  · Yükleme `POST /personnel/kartduzenle/{id}/kvkk` — backend #249'dan beri firma hesabına 403; burası
 *    denetmen sayfası olduğu için doğru. Belge 2030-01-01 son kullanma ile yazılır, bayrağa dokunmaz.
 *  · 🚨 Özel İzin ucunda backend'de staff kontrolü YOK (firma hesabı kendi kadrosuna verebilir; rehberde
 *    Deniz'e bildirilmiş açık) — ekranda söylenmiyor, yukarıdaki not ve knowledgebase'de duruyor.
 *  · Kimlik doğrulama reddi (yetki) backend'de 400 ile döner (403 değil) — `isStaffRefusal` mesajdan yakalar.
 *
 * Backlog #273/#279 (2026-10-06): Kişi Listesi'nin belge kareleri bu sayfayı YENİ SEKMEDE açar
 * (`?tab=belgeler&belge=<anahtar>`, KVKK → `?tab=detaylar`). Dosyası olan belgenin inceleme penceresi açılır;
 * dosyası olmayanın (gri kare) kutusu vurgulanır ve görünüme kaydırılır — Yükle orada. Yeni sekmede router
 * state'i olmadığı için "geri" hedefi `?geri=` / `?geriEtiket=` parametresinden okunur (kisiBaglantilari.js);
 * state varsa (aynı sekmeden gelinmişse, #262) o kazanır.
 * Backlog #481 (2026-10-19): tıklanan şeyin yükleme alanı DOSYASI OLSA DA kırmızı çerçevelenir (`?belge=<anahtar>` belgeleri,
 * `?vurgu=kvkk|kkd|kimlik` Kontroller kartlarını; `belge` ayrıca dosyası varsa pencereyi açar, `vurgu` açmaz). Çerçeve bir
 * sekme değişimine ya da herhangi bir yazmaya (yükleme, onay, işaretleme → `reload`) kadar durur; Giriş Kartı / Kart
 * Yazdır'ın sayfa içi atlamaları da aynı çerçeveyi koyar. Her belge kutusunda Yükle / Yeniden Yükle var:
 * onaylı olanda da — kart basılmış olması yüklemeyi hiçbir zaman engellemez. SGK/İSG → BelgeVaryantModal,
 * KVKK → Detaylar sekmesindeki dosya girdisi, kalanı → BelgeYukleModal (tür kimliği personelBelgeService'te).
 *
 * Backlog #296 (2026-10-06): Özel İzin kartı geçmişi gösterir. Backend (#280) izni silmez, iptal eder: elle geri alma
 * (iptalSebebi 1) ve belgeler tamamlanınca kendiliğinden iptal (iptalSebebi 2). Kart aktif izni eskisi gibi yazar
 * (+ vereni), altında "Geçmiş" başlığıyla iptal edilenleri: tip, veren (givenByAdi; null = 2026-08-25 öncesi →
 * "bilinmiyor"), iptal yazısı. Veri `GET /personnel/{id}/single-permit/gecmis?fuarId=`; okunamazsa kart geçmişsiz açılır.
 * Backlog #297 madde 2: backend #295'ten beri onay (status 1) `gecerlilikTarihi` ister — inceleme penceresine
 * "Geçerlilik tarihi" girdisi eklendi (eski son kullanma bugün/sonrasıysa ön dolu, değilse boş; tarihsiz Onayla kapalı).
 * KVKK'nın tek tıkla Onayla'sı belgenin kendi ileri tarihini gönderir, yoksa aynı pencereyi açar. Paylaşımlı belge (madde 3)
 * ve firma tarafı yükleme formları (madde 1, 4, 5) henüz yapılmadı.
 *
 * Backlog #264 (backend #263): SİGORTALI FİRMA — kişinin SGK'sını yatıran firma (işe alandan ayrı, kişi başına tek,
 * geçmişli, yalnızca SAKA personeli). Başlıkta rozet; Detaylar sekmesinde SigortaFirmaKarti (seç/değiştir/kaldır +
 * geçmiş); SGK inceleme penceresinde SigortaFirmaBelgeBlogu (Hizmet Dökümü'nde sahibini tek tıkla ya da onaylarken,
 * tek kişilik SGK dosyasında firma seçerek). Servis: sigortaFirmaService.js. Listelerdeki yazı: PersonelKart.jsx.
 *
 * ── Backlog #366 #367 #363 #365 #368 #358 #370 #374 #380 #384 (2026-10-13): sayfa yeniden kuruldu ──
 * Firma anahtarı (firmalı / firmasız görünüm) KALKTI. Tek okuma `GET /personnel/{id}/detay?fuarId=<üst çubuk>`
 * (`getKisiDetay`): `person = detay.kisi` (Kişi Listesi satırı), firma blokları `detay.firmalar[]` (kart-karari girdileri),
 * `detay.belgeIsteyenFirmalar` (belge başına hangi firma istiyor / eksik). Eski firmalı rota aynı sayfayı açar, firmaId
 * yalnızca varsayılan "geri" bağlantısı için okunur.
 * Başlık = künye (Components/Kisi/Detay/KunyeBasligi: fotoğraf, ad, TC, uyruk, telefon, e-posta + "Düzenle ve Gör" →
 * GET/PATCH /kunye); sekmelerden ulaşılan hiçbir bilgi başlıkta rozet olarak durmaz. Sekmeler: İSG Belgeleri (Kişisel |
 * Meslek | Firma Belgeleri, `?alt=`) · Giriş Kartı · Firmalar (Çalışan | İşveren) · Kontroller (Kimlik Doğrulama, KVKK, KKD,
 * Özel İzin, Giriş Yasağı) · Kullanıcılar. "Detaylar" kalktı; eski `?tab=meslek` / `?tab=detaylar` bağlantıları
 * kisiBaglantilari.sekmeCozumle ile çözülür. Üst çubukta fuar yoksa fuara bağlı kısımlar "Önce üst çubuktan bir fuar seçin"
 * der, geri kalanı çalışır. Yeniden okumada (yazma, fuar değişimi) içerik silinmez — yalnızca kişi değişince tam ekran
 * "Yükleniyor" çıkar — böylece açık pencereler ve sekme durumu korunur.
 * `kisi.gerekliBelgeler` EN İYİ firmayı izler: istenen belge kümesi gerekliBelgeler + belgeIsteyenFirmalar'ın birleşimidir ve
 * "kimin için eksik" satırı belgeIsteyenFirmalar'dan gelir (birden çok firma varken).
 *
 * Backlog #376 (backend #375, 2026-10-13): Kontroller'deki KVKK kartı `Components/Kisi/Detay/KvkkKarti`e çıktı — iki satır:
 * Dijital Onay (KVKK Gönder / Yeniden Gönder, onay + üretilen belge, onay + 1 yıl) ve Islak İmzalı Belge (Yok | Alındı + yükleme,
 * yükleme + 1 yıl). Eski "Kişi Kaydı" satırı Alındı'ya katlandı. Sayfada kalan: dosya yükleme / onaylama / Alındı yazma işleri
 * (handleKvkkYukle · handleKvkkOnayla · handleKvkkStatus) ve gizli dosya girdisinin açılması. Backend #375 yapılana kadar gönderme,
 * onay ve 1 yıllık süreler `services/kvkkDijitalOnayService.js`teki mock'tan gelir (USE_MOCK_DATA).
 */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams, Link } from "react-router-dom";
import {
  Container, Card, CardBody, CardHeader, Row, Col, Button, Badge, Spinner, Alert, Input, Label,
  Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, TabContent, TabPane,
} from "reactstrap";
import {
  ArrowLeft, ShieldCheck, Landmark, HardHat, HeartPulse, GraduationCap,
  Building2, CheckCircle2, XCircle, RotateCcw, FileText, Briefcase,
  ShieldQuestion, ShieldX, KeyRound, AlertTriangle, IdCard, CreditCard, Users, Trash2,
} from "lucide-react";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import KisiDosyaLink from "../../../../Components/Kisi/KisiDosyaLink";
import { PersonelSayacStack } from "../../../../Components/Kisi/PersonelKartParcalari";
import { PersonelBelgeKutusu, FirmaBelgelerKarti } from "../../../../Components/Kisi/PersonelBelgeKutusu";
import useSablonHaritasi from "../../../../Components/Common/useSablonHaritasi";
import TarihGirdisi from "../../../../Components/Common/TarihGirdisi";
import MeslekiEgitimKartlari from "../../../../Components/Kisi/MeslekiEgitimKartlari";
// #466: meslekler kişinindir (fuarsız da görünür, tek tek eklenir/kaldırılır); eski fuar+firma+PATCH `MeslekKarti` ve MeslekSecici bu sayfadan kalktı.
import KisiMeslekleriKarti from "../../../../Components/Kisi/KisiMeslekleriKarti";
import { kartKararBirlestir } from "../../../../Components/Kisi/kartBirlestir";
import { kisiMeslekleri, meslekiYuvalar, etiketsizSertifikalar } from "../../../../Components/Kisi/meslekler";
import MainContext from "../../../../Components/Contexts/MainContext";
import { getKisiDetay, reviewPersonelDocument, getKisiSilmeKontrolu, kaliciSilKisi } from "../../../../services/personnelAdminService";
import KontrolluSilDugmesi from "../../../../Components/Common/KontrolluSilDugmesi";
import {
  setKvkkStatus, kimlikBelgesiniKaldir,
  getSinglePermit, getSinglePermitGecmisi,
  isStaffRefusal, KIMLIK_DURUM, OZEL_IZIN_TIPLERI, OZEL_IZIN_IPTAL_SEBEBI,
} from "../../../../services/kisiAdminService";
import { FILE_APPROVAL_STATUS } from "../../../../services/projectService";
// Backlog #142/#145/#250 — SGK/İSG varyantları, paylaşımlı belgede çalışan başına karar, belge taşıma, havuz.
import BelgeVaryantModal from "../../../../Components/Kisi/BelgeVaryantModal";
import BelgeYukleModal from "../../../../Components/Kisi/BelgeYukleModal";
import BelgeTasimaModal, { tasimaMesaji } from "../../../../Components/Kisi/BelgeTasimaModal";
import KisiHavuzKarti from "../../../../Components/Kisi/KisiHavuzKarti";
import KartYazdirModal from "../../../../Components/Kisi/KartYazdirModal";
// #471: Kişi Listesi'ndeki Kimlik Doğrula penceresinin aynısı (yerel KimlikModal kalktı).
import KimlikDogrulamaModal from "../../../../Components/Kisi/KimlikDogrulamaModal";
import KimlikBelgesiYonlendirme from "../../../../Components/Kisi/KimlikBelgesiYonlendirme";
import OzelIzinModal from "../../../../Components/Kisi/OzelIzinModal";
import { geriHedefiOku, sekmeCozumle, VURGU_SINIFI } from "../../../../Components/Kisi/kisiBaglantilari";
import FairContext from "../../../../Components/Contexts/Management/FairContext";
import { useTasimaNotlari, tasimaNotu } from "../../../../Components/Kisi/belgeTasimaNotu";
import {
  BELGE_SABLON_TIPI, belgeAnahtariTipId, belgeVaryantAdi, decidePaylasimliBelge, dosyaHatasi, paylasimliMi, uploadKvkkBelgesi, tasiBelge,
  BELGE_TIP, donemYaz,
} from "../../../../services/personelBelgeService";
// #297 / #268: paylaşımlı belgeyi onaylarken belgenin tarihi ve (Hizmet Dökümü) ayı — firma tarihsiz yükler, personel girer.
import {
  PaylasimliOnayAlanlari, ilkOnayAlanlari, onayAlanlariGecerli, onayGovdesi,
} from "../../../../Components/Firma/PaylasimliBelgeKararParcalari";
// #367 #365 #368 #374 #380 — sekme gövdeleri ve künye başlığı kendi dosyalarında (Components/Kisi/Detay).
import KunyeBasligi from "../../../../Components/Kisi/Detay/KunyeBasligi";
import DuzenlemeTalebiBildirimi from "../../../../Components/Kisi/DuzenlemeTalebiBildirimi";
import GirisKartiSekmesi from "../../../../Components/Kisi/Detay/GirisKartiSekmesi";
import KisiFirmalarSekmesi from "../../../../Components/Kisi/Detay/KisiFirmalarSekmesi";
import KkdKarti from "../../../../Components/Kisi/Detay/KkdKarti";
import KvkkKarti from "../../../../Components/Kisi/Detay/KvkkKarti";
import { kvkkMockAlindi, kvkkMockYuklendi } from "../../../../services/kvkkDijitalOnayService";
import YasakKarti from "../../../../Components/Kisi/Detay/YasakKarti";
import KisiKullanicilarSekmesi from "../../../../Components/Kisi/Detay/KisiKullanicilarSekmesi";
import { useTranslation } from "react-i18next";
import i18n, { currentLocaleTag } from "../../../../i18n";

/**
 * Sözleşmedeki beş anahtar + meslek kurallarının ekleyebildiği ikisi. Bilinmeyen bir
 * anahtar (`fileType{id}`) geldiğinde etiket olarak anahtarın kendisi kullanılır —
 * sayfanın kırılmaması, kataloğun genişleyebilmesinden daha az önemli değil.
 */
const BELGE_META = {
  kvkk: { label: "KVKK", icon: ShieldCheck },
  sgk: { label: "SGK", icon: Landmark },
  isg: { get label() { return i18n.t("moduller:personelDetay.isgEgitimi"); }, icon: HardHat },
  saglik: { get label() { return i18n.t("moduller:personelDetay.saglikOnayi"); }, icon: HeartPulse },
  meslekiEgitim: { get label() { return i18n.t("moduller:personelDetay.meslekiEgitim"); }, icon: GraduationCap },
  yuksekteCalisma: { get label() { return i18n.t("moduller:personelDetay.yuksekteCalisma"); }, icon: HardHat },
  asiKarti: { get label() { return i18n.t("moduller:personelDetay.asiKarti"); }, icon: HeartPulse },
  // file_type 90 — bir meslek kuralı istediğinde `documents{}`'e girer (#131).
  kimlikFotografi: { get label() { return i18n.t("moduller:personelDetay.kimlikFotografi"); }, icon: IdCard },
};

const belgeMeta = (key) => BELGE_META[key] ?? { label: key, icon: FileText };

function statusBadge(status) {
  const info = status != null ? FILE_APPROVAL_STATUS[status] : null;
  return info ? <Badge color={info.color}>{info.label}</Badge> : <Badge color="secondary">{i18n.t("moduller:personelDetay.kayitYok")}</Badge>;
}

function KimlikBadge({ durum }) {
  const meta = KIMLIK_DURUM[durum] ?? KIMLIK_DURUM[0];
  const Icon = durum === 1 ? ShieldCheck : durum === 2 ? ShieldX : ShieldQuestion;
  return (
    <Badge color={meta.color} className="d-inline-flex align-items-center gap-1 fw-normal">
      <Icon size={12} />{meta.label}
    </Badge>
  );
}

// Grup satırı olmayan hesaplar da backend'de "firma" sayılır — yetki reddi çoğu zaman buradan çıkar.
function staffAwareMessage(error) {
  if (isStaffRefusal(error)) return i18n.t("moduller:personelDetay.buIslemSakaPersoneliYetkisi");
  return error.message;
}

// #363 #367 #368 #380: Belgeler → "İSG Belgeleri" (alt sekmeler aşağıda), Meslek ve Detaylar sekmeleri kalktı, "Giriş Kartı" ve
// "Kullanıcılar" geldi. `kimlik` anahtarı KASITLI kalıyor ("Kontroller", #284): Kart Yazdır penceresinin ve uygunsuzluk listesinin
// yeni sekme bağlantıları (`?tab=kimlik`) bozulmasın. Anahtarlar kisiBaglantilari.KISI_SEKMELERI ile aynı sırada.
const TABS = [
  { key: "belgeler", get label() { return i18n.t("moduller:personelDetay.isgBelgeleri"); }, Icon: FileText },
  { key: "giris", get label() { return i18n.t("moduller:personelDetay.girisKarti"); }, Icon: CreditCard },
  { key: "firmalar", get label() { return i18n.t("moduller:personelDetay.firmalar"); }, Icon: Building2 },
  { key: "kimlik", get label() { return i18n.t("moduller:personelDetay.kontroller"); }, Icon: IdCard },
  { key: "kullanicilar", get label() { return i18n.t("moduller:personelDetay.kullanicilar"); }, Icon: Users },
];

// #363: İSG Belgeleri alt sekmeleri (`?alt=`).
const BELGE_ALTLARI = [
  { key: "kisisel", get label() { return i18n.t("moduller:personelDetay.kisisel"); } },
  { key: "meslek", get label() { return i18n.t("moduller:personelDetay.meslek"); } },
  { key: "firma", get label() { return i18n.t("moduller:personelDetay.firmaBelgeleri"); } },
];

// #363: Kişisel alt sekmesinin sabit üçlüsü; Mesleki Eğitim ve mesleğin eklediği belgeler Meslek alt sekmesinde. KVKK Kontroller'de.
const KISISEL_BELGELER = ["sgk", "isg", "saglik"];
// #734: the passport / ID image (file_type 90, `kimlikFotografi`) left this list — it belongs to the identity check, so it shows on the
// Kontroller tab next to the Kimlik doğrulama section (KIMLIK_BELGESI below), not under İSG Belgeleri › Meslek.
// WAS: const MESLEK_BELGELERI = ["meslekiEgitim", "yuksekteCalisma", "asiKarti", "kimlikFotografi"];
const MESLEK_BELGELERI = ["meslekiEgitim", "yuksekteCalisma", "asiKarti"];
const KIMLIK_BELGESI = "kimlikFotografi";

// WAS: const SECIM_YOK = "Önce üst çubuktan bir fuar seçin";
// #349: read at render time, so it follows the UI language.
const secimYok = () => i18n.t("moduller:personelDetay.onceUstCubuktanBirFuarSecin");

const tarihYaz = (v) => (v ? new Date(v).toLocaleDateString(currentLocaleTag()) : "—");

// Yerel takvim günü (yyyy-MM-dd): backend gecerlilikTarihi'ni "bugün ya da sonrası" diye İstanbul gününe göre denetler.
// toISOString() UTC günü verir ve gece yarısı civarında bir gün geri kalır.
const bugunYmd = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

// #297: belgenin mevcut son kullanma tarihi bugün ya da sonrasıysa onay penceresinde ön dolu gelir; geçmişse (ya da yoksa —
// firma belgeleri artık tarihsiz yüklenir) boş: backend geçmiş bir tarihi reddeder.
const gelecekTarih = (tarih) => {
  const gun = tarih ? String(tarih).slice(0, 10) : "";
  return gun >= bugunYmd() ? gun : "";
};

// #297: `status` hiç incelenmemiş ama geçerli bir belgede de 1 döner (eski geçerlilik kuralı); personelin verdiği karar
// `reviewStatus`ta. Onayla yalnızca KARAR verilmiş ve yürürlükteki belgede kapanır — yoksa yeni yüklenen belge hiç onaylanamaz
// ve Özel İzni kendiliğinden iptal eden "personelin onayladığı belge" şartı hiçbir zaman sağlanmaz. Paylaşımlı belgenin kararı
// ayrı uçta ve çalışan başına; orada eski davranış (status) kalır.
const resmenOnayli = (doc) => doc?.status === 1 && (paylasimliMi(doc) || doc?.reviewStatus === 1);

// #296 — Özel İzin kartı. `satir`: aktif izin ya da /single-permit/gecmis satırı (typeId + typeString ortak).
// #475: bilinmeyen bir tip için backend'in kendi dilindeki adı (`typeAdi`) yedek olur.
const izinTipiEtiketi = (satir) => {
  const id = satir.typeId ?? satir.permitTypeId;
  return OZEL_IZIN_TIPLERI.find((t) => t.value === id)?.label ?? satir.typeAdi ?? `Tip ${id}`;
};

// `givenByAdi` null = 2026-08-25'ten önce verilmiş (kimse kaydetmiyordu): boş değil, "bilinmiyor".
// WAS (until #475): `Veren: ${satir.givenByAdi ?? "bilinmiyor"}${satir.givenAt ? `, ${tarihYaz(satir.givenAt)}` : ""}` — Türkçe sabit metin.
const izinVerenYaz = (satir) =>
  i18n.t("moduller:personelDetay.izinVeren", {
    ad: satir.givenByAdi ?? i18n.t("moduller:personelDetay.verenBilinmiyor"),
    v: satir.givenAt ? `, ${tarihYaz(satir.givenAt)}` : "",
  });

function izinIptalYazisi(satir) {
  const tarih = tarihYaz(satir.iptalTarihi);
  if (satir.iptalSebebi === OZEL_IZIN_IPTAL_SEBEBI.BELGELER_TAMAMLANDI) {
    return i18n.t("moduller:personelDetay.otomatikIptalEdildiBelgelerTamamlandi", { tarih });
  }
  if (satir.iptalSebebi === OZEL_IZIN_IPTAL_SEBEBI.ELLE) {
    return i18n.t("moduller:personelDetay.kaldirildi", { v: satir.iptalEdenAdi ? `: ${satir.iptalEdenAdi}` : "", tarih });
  }
  return `${satir.iptalSebebiAdi ?? i18n.t("moduller:personelDetay.iptalEdildi")}, ${tarih}`;
}

export default function PersonelDetayPage() {
  const { t: tx } = useTranslation("moduller");
  const { firmaId: firmaIdParam, personId: personIdParam } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedFuarId } = useContext(MainContext);
  const { getFairs } = useContext(FairContext);

  const personId = Number(personIdParam);
  // #365: firma bağlamı yok. Fuar: adresteki, yoksa üst çubuktaki; ikisi de yoksa null (fuara bağlı kısımlar "fuar seçin" der).
  const fuarId = Number(searchParams.get("fuarId")) || Number(selectedFuarId) || null;
  // #503: kurumun verdiği boş form / örnek (KVKK 56, İSG katılım listesi 98), arayüz dilinde; fuar yoksa yalnızca genel şablonlar.
  const sablonlar = useSablonHaritasi(fuarId);

  // Liste sayfasının gönderdiği `?belge=<anahtar>` kişi başına bir kez açılır.
  const belgeParam = searchParams.get("belge");
  const belgeAcilanKisi = useRef(null);
  const { tab: activeTab, alt: altParam } = sekmeCozumle(searchParams.get("tab"), searchParams.get("alt"));
  // Mesleki Eğitim / meslek belgeleri Meslek alt sekmesinde: alt verilmemiş eski bağlantı da oraya düşsün.
  const belgeAlt = activeTab === "belgeler"
    ? (altParam ?? (MESLEK_BELGELERI.includes(belgeParam) ? "meslek" : "kisisel"))
    : null;

  function setTab(key, alt = null) {
    const next = new URLSearchParams(searchParams);
    next.set("tab", key);
    if (alt) next.set("alt", alt); else next.delete("alt");
    // state'i taşı: liste sayfasının verdiği "geri dön" adresi (#262) sekme değişince silinmesin.
    setSearchParams(next, { replace: true, state: location.state });
    vurguKoy(null); // #481: sekme değişince çerçeve kalkar
  }

  // #365: sayfanın tek verisi — /detay yanıtı; `person` onun Kişi Listesi satırı.
  const [detay, setDetay] = useState(null);
  const person = detay?.kisi ?? null;
  const firmalar = detay?.firmalar ?? [];
  const [permit, setPermit] = useState(null);
  // #296: bu fuardaki TÜM izin satırları (yeniden eskiye, aktif olan da dahil); kart yalnızca iptal edilenleri ve
  // aktif olanın vereni için kendi satırını kullanır.
  const [permitGecmis, setPermitGecmis] = useState([]);
  // WAS (until #466): const [mesleks, setMesleks] = useState([]); — the meslek catalogue is read by KisiMeslekleriKarti itself now.
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [infoMsg, setInfoMsg] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);
  const [fuarlar, setFuarlar] = useState([]);
  // Birleştirilmiş (gizli) kart açıldıysa: şu an geçerli kartın kimliği. Sayfa salt okunur gösterilir.
  const birlestiId = detay?.birlestirildigiPersonId ?? null;
  const salt = birlestiId != null;
  const yuklenenKisi = useRef(null);

  const [reviewModal, setReviewModal] = useState({ isOpen: false, docKey: null, doc: null });
  const [rejectMode, setRejectMode] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  // #700: kimlik / pasaport görselini doğrudan kaldırma — pencere içi onay adımı ve backend'in reddi (pencerenin arkasındaki sayfa uyarısı görünmez).
  const [kaldirMode, setKaldirMode] = useState(false);
  const [kaldirHata, setKaldirHata] = useState(null);
  // #297: onaylarken belgenin ne zamana kadar sayılacağını personel girer (yyyy-MM-dd; backend #295 zorunlu tutar).
  const [gecerlilik, setGecerlilik] = useState("");
  // #268: Hizmet Dökümü'nün kapsadığı ay ("yyyy-MM") — yalnızca paylaşımlı 96 belgesinin onayında; belgenin kendisine yazılır.
  const [donem, setDonem] = useState("");
  const [reviewing, setReviewing] = useState(false);
  const [kimlikModal, setKimlikModal] = useState(false);
  const [permitModal, setPermitModal] = useState(false);
  const [kartYazdirAcik, setKartYazdirAcik] = useState(false);
  // #142/#145: SGK/İSG varyant penceresi (slot anahtarı) ve belge taşıma penceresi ({ mod, key }).
  const [varyantSlot, setVaryantSlot] = useState(null);
  // #279: SGK/İSG/KVKK dışındaki her kutunun Yükle'si — { key, fileTypeId }.
  const [yukleHedefi, setYukleHedefi] = useState(null);
  const vurguKaydirilan = useRef(null);
  // #481: tıklanan şeyin kırmızı çerçevesi. Başlangıçta adresteki hedef (`?vurgu=` ya da `?belge=`); sekme değişimi ya da yazma
  // (`reload`) onu kapatır (`anahtar: null`), sayfa içi atlama yenisini koyar. `null` = adrese uy. Kişi değişince eski istem düşer.
  const [vurguIstemi, setVurguIstemi] = useState(null);
  const vurguHedefi = vurguIstemi?.personId === personId ? vurguIstemi.anahtar : (searchParams.get("vurgu") ?? belgeParam);
  function vurguKoy(anahtar) { setVurguIstemi({ personId, anahtar }); }
  const [tasima, setTasima] = useState(null);
  const tasimaNotlari = useTasimaNotlari(personId, true, reloadToken);
  // #365: paylaşımlı belge / taşıma pencereleri bir firma ister; birden çok firma varsa hangisinin adına işlem yapıldığı seçilir
  // (varsayılan: kart kararını veren firma).
  const [seciliBelgeFirma, setSeciliBelgeFirma] = useState(null);
  // KVKK belgesi yükleme/onay: "yukle" | "onayla" | null.
  const [kvkkIsi, setKvkkIsi] = useState(null);
  // Gizli KVKK dosya girdisi Kontroller sekmesindeki KVKK kartında. Ref DEĞİL id: render sırasında çağrılan `yukleEylemi`
  // ref okuyan bir kapanış döndürünce react-hooks/refs derlemeyi durduruyor (#284).
  const kvkkDosyaSec = () => document.getElementById("kisi-kvkk-dosya")?.click();

  useEffect(() => { document.title = i18n.t("moduller:personelDetay.personelDetayiFds"); }, []);

  useEffect(() => {
    let ignore = false;
    getFairs()
      .then((res) => { if (!ignore) setFuarlar(res?.data || []); })
      .catch(() => {});
    return () => { ignore = true; };
  }, [getFairs]);

  useEffect(() => {
    let ignore = false;
    async function run() {
      // Aynı kişinin yeniden okunmasında (yazma sonrası, fuar değişimi) içerik silinmez; tam ekran yükleniyor yalnızca kişi
      // değişince çıkar — açık pencereler ve sekmelerin yerel durumu korunur.
      if (yuklenenKisi.current !== personId) setLoading(true);
      setError(null);
      try {
        const data = await getKisiDetay(personId, fuarId);
        if (ignore) return;
        yuklenenKisi.current = personId;
        setDetay(data);
        if (belgeParam && belgeAcilanKisi.current !== personId) {
          belgeAcilanKisi.current = personId;
          const doc = data.kisi?.documents?.[belgeParam];
          if (doc?.fileId != null) {
            setReviewModal({ isOpen: true, docKey: belgeParam, doc });
            setGecerlilik(gelecekTarih(doc.expiryDate));
            setDonem(ilkOnayAlanlari(doc).donem);
          }
        }

        // Ana kayıt zorunlu; yan okumalar (izin) başarısız olursa sayfa yine açılmalı — bu yüzden allSettled.
        const [permitRes, gecmisRes] = await Promise.allSettled([
          fuarId ? getSinglePermit(personId, fuarId) : Promise.resolve(null),
          fuarId ? getSinglePermitGecmisi(personId, fuarId) : Promise.resolve([]),
          // WAS (until #466): getMeslekList(fuarId || 0, { kaldirilanlar: true }) — the meslek card reads its own catalogue.
        ]);
        if (ignore) return;
        setPermit(permitRes.status === "fulfilled" ? permitRes.value : null);
        // Geçmiş okunamazsa (eski backend, yetki) kart yalnızca aktif izinle açılır.
        setPermitGecmis(gecmisRes.status === "fulfilled" ? gecmisRes.value : []);
      } catch (e) {
        if (!ignore) {
          setError(e.message);
          setDetay(null);
          yuklenenKisi.current = null;
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    }
    run();
    return () => { ignore = true; };
  }, [personId, fuarId, reloadToken, belgeParam]);

  function showInfo(msg) {
    setInfoMsg(msg);
    setTimeout(() => setInfoMsg(null), 4000);
  }

  // Her yazma (yükleme, onay, işaretleme) bunu çağırır: #481 çerçevesi işini yapmıştır, kalkar.
  function reload() { vurguKoy(null); setReloadToken((t) => t + 1); }

  // #372: hiçbir mesleğe sayılmayan etiketsiz Mesleki Eğitim sertifikasını bir mesleğe atar (tasi { meslekId });
  // etiket değişikliği bir taşımadır, incelemeyi sıfırlar.
  async function sertifikaEtiketle(fileId, meslekId) {
    setError(null);
    try {
      await tasiBelge(personId, fileId, { meslekId });
      showInfo(tx("personelDetay.sertifikaMeslegeAtandi"));
      reload();
    } catch (e) {
      setError(staffAwareMessage(e));
    }
  }

  function openReviewModal(docKey, doc) {
    setReviewModal({ isOpen: true, docKey, doc });
    setRejectMode(false);
    setRejectReason("");
    setKaldirMode(false);
    setKaldirHata(null);
    setGecerlilik(gelecekTarih(doc?.expiryDate));
    setDonem(ilkOnayAlanlari(doc).donem);
  }

  function closeReviewModal() {
    setReviewModal({ isOpen: false, docKey: null, doc: null });
    setRejectMode(false);
    setRejectReason("");
    setKaldirMode(false);
    setKaldirHata(null);
    setGecerlilik("");
    setDonem("");
  }

  // #700 (backend #699): kimlik / pasaport görselini Havuz yolu olmadan kaldırır; backend durum 3'ü (ve belgeye dayanan 1'i) 0'a çevirir.
  async function handleKimlikBelgesiKaldir() {
    setReviewing(true);
    setKaldirHata(null);
    try {
      await kimlikBelgesiniKaldir(personId);
      showInfo(tx("personelDetay.kimlikBelgesiKaldirildi"));
      closeReviewModal();
      reload();
    } catch (e) {
      setKaldirHata(e.message);
    } finally {
      setReviewing(false);
    }
  }

  async function handleReview(status, reason) {
    const { docKey, doc } = reviewModal;
    setReviewing(true);
    setError(null);
    try {
      // Paylaşımlı belge (96/98) dosya başına değil ÇALIŞAN başına incelenir; dosya ucu 400 verir.
      if (paylasimliMi(doc)) {
        // #297 / #268: onayda belgenin tarihi (firma tarihsiz yükler) ve Hizmet Dökümü'nün ayı da gider; yalnızca belgedekinden farklıysa.
        await decidePaylasimliBelge(doc.paylasimliBelgeFirmaId, doc.paylasimliBelgeId, {
          personIds: [personId], status, rejectReason: reason,
          ...(status === 1 ? onayGovdesi(doc, { tarih: gecerlilik, donem }) : {}),
        });
      } else {
        await reviewPersonelDocument(doc.fileId, {
          status, rejectReason: reason, gecerlilikTarihi: status === 1 ? gecerlilik : undefined,
        });
      }
      showInfo(tx("personelDetay.belgesiGuncellendi2", { label: belgeMeta(docKey).label }));
      closeReviewModal();
      reload();
    } catch (e) {
      setError(e.message);
    } finally {
      setReviewing(false);
    }
  }

  async function handleKvkkStatus(statusId) {
    setError(null);
    try {
      await setKvkkStatus(personId, statusId);
      kvkkMockAlindi(personId, statusId === 3); // #376: backend #375 gelene kadar "Alındı + 1 yıl" bellekte tutulur
      showInfo(statusId === 3 ? tx("personelDetay.islakImzaliKvkkBelgesiAlindi") : tx("personelDetay.islakImzaliKvkkIsaretiKaldirildi"));
      reload();
    } catch (e) {
      setError(staffAwareMessage(e));
    }
  }

  // #137: KVKK BELGESİ yükleme — durum bayrağına (`person_kvkk_status_id`) dokunmaz.
  async function handleKvkkYukle(file) {
    const sorun = dosyaHatasi(file);
    if (sorun) { setError(sorun); return; }
    setKvkkIsi("yukle");
    setError(null);
    try {
      // Doğrulama reddi bu uçta 500 döner; `result: false` da aynı şekilde hata sayılır.
      const res = await uploadKvkkBelgesi(personId, file, `${person.name} ${person.surname}`);
      if (res?.result === false) throw new Error(res.message || tx("personelDetay.kvkkBelgesiYuklenemedi"));
      kvkkMockYuklendi(personId); // #376: backend #375 gelene kadar "yükleme + 1 yıl" bellekte tutulur
      showInfo(tx("personelDetay.kvkkBelgesiYuklendi"));
      reload();
    } catch (e) {
      setError(staffAwareMessage(e));
    } finally {
      setKvkkIsi(null);
    }
  }

  // #138: KVKK BELGESİNİ tek tıkla onayla (bayrak değil — o ayrı düğme).
  // #297: backend onayda bir geçerlilik tarihi ister. Personelin yüklediği KVKK zaten ileri bir tarihle yazılır
  // (2030-01-01), o tarih varsa tek tıklama sürer; yoksa/geçmişse tarihi soran inceleme penceresi açılır.
  async function handleKvkkOnayla() {
    const tarih = gelecekTarih(documents.kvkk?.expiryDate);
    if (!tarih) {
      openReviewModal("kvkk", documents.kvkk);
      return;
    }
    setKvkkIsi("onayla");
    setError(null);
    try {
      await reviewPersonelDocument(documents.kvkk.fileId, { status: 1, gecerlilikTarihi: tarih });
      showInfo(tx("personelDetay.kvkkBelgesiOnaylandi"));
      reload();
    } catch (e) {
      setError(staffAwareMessage(e));
    } finally {
      setKvkkIsi(null);
    }
  }

  // Listeden gelindiyse (Kişi Listesi, Firma Detay › Personel) aynı yere, süzgeç/arama/sayfa/kaydırma
  // korunarak dön (#262); doğrudan açıldıysa eski varsayılan. Önce router state'i (aynı sekmeden gidildi), yoksa `?geri=`
  // (yeni sekmede açılan bağlantılar, #273), ikisi de yoksa varsayılan: firmalı (eski) rota o firmanın ekip sayfası, firmasız rota Kişi Listesi.
  const geriState = typeof location.state?.from === "string" ? location.state : null;
  const geriParam = geriHedefiOku(searchParams);
  const varsayilanGeri = firmaIdParam
    ? { from: `/Management/Firmalar/Personel/${Number(firmaIdParam)}${fuarId ? `?fuarId=${fuarId}` : ""}`, label: tx("personelDetay.personelListesineDon") }
    : { from: "/Management/Kisi/Personeller", label: tx("personelDetay.kisiListesineDon") };
  const backHref = geriState?.from ?? geriParam?.from ?? varsayilanGeri.from;
  const backLabel = geriState?.fromLabel ?? geriParam?.fromLabel ?? varsayilanGeri.label;
  const documents = person?.documents ?? {};
  // #372: Mesleki Eğitim yuvaları FUAR geneli bir karardır; satırda yoksa (eski yanıt) bir firmanın kart-karari girdisinden alınır.
  const meslekSatiri = person?.meslekiEgitimler ? person : (firmalar.find((f) => f.kisi?.meslekiEgitimler)?.kisi ?? person);
  // #466: kartın hangi meslekle basılabileceği (`kartMeslekleri[]`) bir firmanın kararına aittir: kartın basılacağı firmanın girdisi
  // (Giriş Kartı sekmesi ve Kart Yazdır ile aynı seçim); fuar ya da görevlendirme yoksa karar yoktur, kart durumu yazılmaz.
  const kartKarariGirdisi = fuarId && firmalar.length > 0 ? kartKararBirlestir(firmalar, { tercihFirmaId: detay?.kartFirmaId })?.secili?.kisi : null;
  const kartMeslekSatiri = kartKarariGirdisi?.kartMeslekleri ? kartKarariGirdisi : (person?.kartMeslekleri ? person : null);
  const fuarAdiOku = (id) => fuarlar.find((f) => Number(f.id) === Number(id))?.nameTR || (id ? `Fuar #${id}` : "");
  const fuarAdi = fuarId ? fuarAdiOku(fuarId) : "";
  const adSoyad = person ? `${person.name} ${person.surname}` : "";

  // #365: istenen belge kümesi = satırın (en iyi firmanın) gerekliBelgeler'i + belgeIsteyenFirmalar'da en az bir firmanın istediği anahtarlar
  // (yalnızca bir firmanın mesleği isteyen belge `kisi.documents`'a kopyalanır ama gerekliBelgeler'de olmayabilir).
  const belgeIsteyen = detay?.belgeIsteyenFirmalar ?? {};
  const gerekli = [...new Set([
    ...(person?.gerekliBelgeler ?? Object.keys(documents)),
    ...Object.keys(belgeIsteyen).filter((k) => (belgeIsteyen[k] || []).length > 0),
  ])];
  const kisiselIstenen = KISISEL_BELGELER.filter((k) => gerekli.includes(k));
  const meslekIstenen = MESLEK_BELGELERI.filter((k) => gerekli.includes(k));
  const kisiselDiger = Object.keys(documents).filter(
    (k) => k !== "kvkk" && !KISISEL_BELGELER.includes(k) && !MESLEK_BELGELERI.includes(k) && !gerekli.includes(k),
  );
  const kisiselKalanDiger = KISISEL_BELGELER.filter((k) => !gerekli.includes(k) && documents[k]?.fileId != null);
  const meslekDiger = MESLEK_BELGELERI.filter((k) => k !== "meslekiEgitim" && !gerekli.includes(k) && documents[k]?.fileId != null);
  const onaysiz = (keys) => keys.some((k) => documents[k]?.status !== 1);
  // #514: Kişisel kartının sayacı yalnızca kartta çizilen belgelerin durumudur (WAS: person.statusCounts — tüm belgeler).
  const kisiselSayac = [...kisiselIstenen, ...kisiselKalanDiger, ...kisiselDiger].reduce((s, k) => {
    const durum = documents[k]?.status;
    if (durum === 0) s.pending += 1;
    else if (durum === 1) s.approved += 1;
    else if (durum === 2) s.rejected += 1;
    return s;
  }, { pending: 0, approved: 0, rejected: 0 });
  // "Kimin için eksik" satırı yalnızca birden çok firma varken VE yalnızca meslek belgelerinde anlamlı (#400): kişisel
  // belgeler (SGK / İSG / Sağlık) kişinin kendisinindir, "Eksik: ACAR MOBİLYA, ÖRYAP" gibi firma listesi karışıklık
  // yaratıyordu. Mesleki Eğitim ise işe alıma (meslek) bağlı olduğu için hangi firma için eksik olduğu söylenir.
  const eksikFirmaAdlari = (key) => (firmalar.length > 1 && MESLEK_BELGELERI.includes(key)
    ? (belgeIsteyen[key] || []).filter((f) => f.eksik).map((f) => f.firmaShortname || f.firmaName || `Firma #${f.firmaId}`)
    : []);
  // ÖNCEDEN (#743'e kadar): the URL's firmaId was ignored, so a worker hired by two companies at the fair could open the
  // SGK / İSG pop-up for the other company than the profile he was reached from.
  // const belgeFirmaId = seciliBelgeFirma != null && firmalar.some((f) => Number(f.firmaId) === Number(seciliBelgeFirma))
  //   ? Number(seciliBelgeFirma)
  //   : (detay?.kartFirmaId ?? firmalar[0]?.firmaId ?? null);
  const firmalarda = (id) => id != null && firmalar.some((f) => Number(f.firmaId) === Number(id));
  const belgeFirmaId = firmalarda(seciliBelgeFirma)
    ? Number(seciliBelgeFirma)
    : firmalarda(firmaIdParam)
      ? Number(firmaIdParam)
      : (detay?.kartFirmaId ?? firmalar[0]?.firmaId ?? null);
  const firmaBelgeBloklari = firmalar.filter((g) => (g.kisi?.firmaBelgeGruplari || g.belgeGruplari || []).length > 0);
  const kvkkBelge = documents.kvkk;
  // #296: aktif izin satırı (vereni için) ve iptal edilenler. Liste zaten yeniden eskiye geliyor.
  const aktifIzinSatiri = permitGecmis.find((r) => r.aktif) ?? null;
  const iptalIzinleri = permitGecmis.filter((r) => !r.aktif);
  // #475 (backend #474): kimliği doğrulanmamış kişiye yeni Özel İzin verilmez; geri almak her zaman serbest.
  const kimlikTamam = person?.kimlikDogrulama?.durum === 1;
  // #297: Onayla, geçerlilik tarihi girilip bugün ya da sonrası olmadan açılmaz (paylaşımlı belgede tarih istenmez).
  // Paylaşımlı belgede (#297 / #268) tarih belgede yoksa ya da geçmişse, Hizmet Dökümü'nde ay yoksa girilmeden Onayla açılmaz (backend 400 verir).
  // WAS (until #297): const onayTarihiTamam = !reviewModal.doc || paylasimliMi(reviewModal.doc) || (!!gecerlilik && gecerlilik >= bugunYmd());
  const onayTarihiTamam = !reviewModal.doc
    || (paylasimliMi(reviewModal.doc)
      ? onayAlanlariGecerli(reviewModal.doc, { tarih: gecerlilik, donem })
      : (!!gecerlilik && gecerlilik >= bugunYmd()));
  // #719: kimlik / pasaport belgesi (birleştirilmiş salt okunur kart değilse) burada onaylanmaz / reddedilmez — karar Kimlik Doğrula penceresindedir
  // (genel inceleme ucu kimlik durumuna dokunmaz; iki durum birbiriyle çelişirdi). Aç, Kaldır (#700), Taşı ve Havuza al kalır.
  const kimlikBelgesiKimlikPenceresinde = reviewModal.docKey === "kimlikFotografi" && !salt;
  // #273: Kişi Listesi'nde bir kareye tıklayıp gelindi → o kutu/kart öne çıkar ve görünüme kaydırılır.
  // #481: dosyası olan belgede de (pencere ayrıca açılır, yukarıdaki yükleme efekti), KVKK / KKD / Kimlik kartlarında da.
  // WAS (until #481): const vurguKey = !loading && person && belgeParam && documents[belgeParam]?.fileId == null ? belgeParam : null;
  const vurguKey = !loading && person ? vurguHedefi : null;
  useEffect(() => {
    if (!vurguKey) { vurguKaydirilan.current = null; return; } // çerçeve kalktı: aynı hedefe yeniden atlanınca yine kaydır
    if (vurguKaydirilan.current === vurguKey) return;
    // Mesleki Eğitim'in yüklemesi Meslek alt sekmesinde (#363); KVKK / KKD / Kimlik kartları Kontroller'de (#368, #481).
    const el = document.getElementById(vurguKey === "meslekiEgitim" ? "meslek-egitim-karti" : `belge-karti-${vurguKey}`);
    // Bulunamadı ya da sekmesi henüz gizli (sayfa içi atlamada çerçeve sekme adresinden önce gelir): sekme değişince efekt yeniden koşar.
    if (!el || el.offsetParent === null) return;
    vurguKaydirilan.current = vurguKey;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [vurguKey, activeTab, belgeAlt]);
  // #142/#145/#279: kutuyu dolduran varyantın adı, "taşındı" notu ve HER kutuda Yükle — onaylı olanda da
  // (yenisini yükleme, bir kartın basılmış olması engel değil). SGK/İSG varyant seçtirir, KVKK Kontroller
  // sekmesindeki dosya girdisini açar, kalanı BelgeYukleModal; türü bilinmeyen anahtarda düğme yok.
  const yukleEylemi = (key) => {
    if (key === "sgk" || key === "isg") return () => setVaryantSlot(key);
    if (key === "kvkk") return kvkkDosyaSec;
    const fileTypeId = belgeAnahtariTipId(key);
    return fileTypeId ? () => setYukleHedefi({ key, fileTypeId }) : undefined;
  };
  const tileEkleri = (key) => ({
    belgeKey: key,
    vurgu: vurguKey === key,
    varyantAdi: documents[key]?.fileId != null ? belgeVaryantAdi(documents[key].fileTypeId) : null,
    tasimaNotu: tasimaNotu(tasimaNotlari.get(documents[key]?.fileId)),
    onYukle: yukleEylemi(key),
    onIncele: () => openReviewModal(key, documents[key]),
    sablon: sablonlar[BELGE_SABLON_TIPI[key]],
  });
  // #734: the identity image is asked for (a meslek rule / the foreign-person rule) or already uploaded → its box shows on Kontroller.
  const kimlikBelgesiVar = gerekli.includes(KIMLIK_BELGESI) || documents[KIMLIK_BELGESI]?.fileId != null;
  // Bir belge kutusu + (birden çok firma varsa) "Eksik: <firmalar>" satırı.
  const belgeKutusu = (key, soluk = false, etiket = null) => {
    const meta = belgeMeta(key);
    const eksik = eksikFirmaAdlari(key);
    return (
      // flex-column: kutunun `h-100`'ü sarmalayıcının yüksekliğini doldurup "Eksik" satırını dışarı taşırmasın.
      <div key={key} className="d-flex flex-column" style={{ flex: "1 1 180px", maxWidth: 240 }}>
        <div className="flex-grow-1">
          <PersonelBelgeKutusu label={etiket ?? meta.label} Icon={meta.icon} doc={documents[key]} soluk={soluk} {...tileEkleri(key)} />
        </div>
        {eksik.length > 0 && <div className="small text-danger mt-1 text-center">{tx("personelDetay.eksik2")}{" "}{eksik.join(", ")}</div>}
      </div>
    );
  };
  const altNokta = (keys) => (onaysiz(keys)
    ? <span className="d-inline-block rounded-circle bg-danger ms-1" style={{ width: 7, height: 7 }} title={tx("personelDetay.onaysizEksikBelgeVar")} />
    : null);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("personelDetay.personelDetayi")} pageTitle={firmaIdParam ? tx("personelDetay.firmalar") : tx("personelDetay.kisiler")} />

        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
          <Link
            to={backHref} state={geriState?.scrollY != null ? { scrollY: geriState.scrollY } : undefined}
            className="d-inline-flex align-items-center gap-1 text-decoration-none"
          >
            <ArrowLeft size={14} />{backLabel}
          </Link>
          {/* #550: only a card nothing points at can be deleted (GET /personnel/{id}/kalici-silme-kontrolu says what still does; 403 without
              page.kisi hides the button). A merged (read-only) card is never offered. WAS: no delete on this page. */}
          {!loading && person && !salt && (
            <KontrolluSilDugmesi
              key={personId} tur="kisi" ad={adSoyad}
              kontrol={() => getKisiSilmeKontrolu(personId)}
              sil={() => kaliciSilKisi(personId)}
              onSilindi={() => navigate(backHref)}
            />
          )}
        </div>

        {error && <Alert fade={false} color="danger">{error}</Alert>}
        {infoMsg && <Alert fade={false} color="success">{infoMsg}</Alert>}

        {loading && (
          <div className="text-center py-5">
            <Spinner color="primary" />
            <p className="mt-2">{tx("common:yukleniyor")}</p>
          </div>
        )}

        {!loading && !person && !error && <Alert fade={false} color="light" className="border">{tx("personelDetay.kisiBulunamadi")}</Alert>}

        {!loading && person && (
          <>
            {birlestiId && (
              <Alert fade={false} color="warning" className="py-2">
                {tx("personelDetay.buKartBaskaBirKarta2")}
                <Link to={`/Management/Kisi/Personeller/${birlestiId}`}>{tx("personelDetay.guncelKartaGit")}</Link>
              </Alert>
            )}

            {/* #749: this kişi's pending Edit Kişi Requests (a company's phone / e-mail change on a locked card), link to the approval list */}
            <DuzenlemeTalebiBildirimi personId={personId} reloadToken={reloadToken} />

            {/* ── Künye başlığı (#367): rozet yok — sekmelerden ulaşılan hiçbir bilgi burada durmaz ── */}
            <KunyeBasligi
              personId={personId} person={person} fuarId={fuarId} reloadToken={reloadToken} salt={salt}
              firmalar={firmalar} tercihFirmaId={detay?.kartFirmaId}
              onChanged={(msg) => { if (msg) showInfo(msg); reload(); }} onError={(msg) => setError(msg)}
            />

            {/* ── Sekmeler (backlog #137) — hepsi monte kalır, böylece Meslek seçimi ve açık taslaklar sekme değişince kaybolmaz ── */}
            <Card className="mb-3">
              <Nav tabs className="nav-tabs-custom border-bottom-0 px-3">
                {TABS.map((t) => (
                  <NavItem key={t.key}>
                    <NavLink
                      href="#"
                      className={`fw-semibold d-inline-flex align-items-center gap-1 ${activeTab === t.key ? "active" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={(e) => { e.preventDefault(); setTab(t.key); }}
                    >
                      <t.Icon size={14} />{t.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </Card>

            <TabContent activeTab={activeTab}>
              {/* ── İSG Belgeleri (#363): Kişisel | Meslek | Firma Belgeleri ───────────────────── */}
              <TabPane tabId="belgeler">
                <Nav pills className="mb-3 gap-1 flex-wrap">
                  {BELGE_ALTLARI.map((a) => (
                    <NavItem key={a.key}>
                      <NavLink
                        href="#" active={belgeAlt === a.key} className="py-1 px-3" style={{ cursor: "pointer" }}
                        onClick={(e) => { e.preventDefault(); setTab("belgeler", a.key); }}
                      >
                        {a.label}
                        {a.key === "kisisel" && altNokta(kisiselIstenen)}
                        {a.key === "meslek" && altNokta(meslekIstenen)}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>

                {/* Kişisel: SGK · İSG · Sağlık (istenenler) + diğer yüklenmişler + Havuz. KVKK Kontroller'de, Mesleki Eğitim Meslek'te. */}
                {belgeAlt === "kisisel" && (
                  <>
                    <Card className="mb-3">
                      <CardHeader className="bg-white border-bottom d-flex align-items-center gap-2 flex-wrap">
                        <h5 className="mb-0"><ShieldCheck size={18} className="me-2 text-primary" />{tx("personelDetay.kisiselBelgeler")}</h5>
                        <div className="ms-auto d-flex align-items-center gap-2">
                          {firmalar.length > 1 && (
                            <Input
                              type="select" bsSize="sm" style={{ width: "auto", maxWidth: 220 }} value={belgeFirmaId ?? ""}
                              title={tx("personelDetay.belgeIslemlerininYapildigiFirma")} onChange={(e) => setSeciliBelgeFirma(Number(e.target.value))}
                            >
                              {firmalar.map((f) => (
                                <option key={f.firmaId} value={f.firmaId}>{f.firmaShortname || f.firmaName || tx("personelDetay.firma", { firmaId: f.firmaId })}</option>
                              ))}
                            </Input>
                          )}
                          {/* #514: backend sayacı tüm belgeleri sayar (Meslek sekmesindeki Kimlik Fotoğrafı dahil); burada yalnızca bu kartta görünenler. */}
                          <PersonelSayacStack counts={kisiselSayac} reserve={false} />
                        </div>
                      </CardHeader>
                      <CardBody>
                        <div className="d-flex flex-wrap gap-3">
                          {kisiselIstenen.map((key) => belgeKutusu(key))}
                          {kisiselIstenen.length === 0 && <div className="text-muted small">{tx("personelDetay.buFuardaKisiselBelgeIstenmiyor")}</div>}
                        </div>
                        {(kisiselKalanDiger.length > 0 || kisiselDiger.length > 0) && (
                          <>
                            <hr />
                            <div className="small text-muted mb-2">{tx("personelDetay.digerYuklenmisBelgelerIstenmiyor")}</div>
                            <div className="d-flex flex-wrap gap-3">
                              {[...kisiselKalanDiger, ...kisiselDiger].map((key) => belgeKutusu(key, true))}
                            </div>
                          </>
                        )}
                      </CardBody>
                    </Card>

                    {/* #250 — türü henüz belli olmayan dosyalar (Havuz). */}
                    <KisiHavuzKarti
                      personId={personId} kisiAd={adSoyad} firmaId={belgeFirmaId} salt={salt} staff
                      reloadToken={reloadToken} onChanged={reload}
                    />
                  </>
                )}

                {/* Meslek: meslek + belge kuralı, Mesleki Eğitim ve mesleğin eklediği belgeler. */}
                {belgeAlt === "meslek" && (
                  <>
                    <Row className="g-3 mb-3">
                      <Col lg={6}>
                        {/* #466: kişinin meslekleri — fuar/firma bağlamı olmadan, kim ekledi ile; tek tek ekle / kaldır / (hafif kuralda) onayla. */}
                        <KisiMeslekleriKarti
                          personId={personId} taraf="denetmen" yazabilir={!salt}
                          meslekler={kisiMeslekleri(person)} kartSatiri={kartMeslekSatiri}
                          yuvalar={meslekiYuvalar(meslekSatiri)} calisanBelgeleri={person.belgeKurali?.belgeler || []}
                          onChanged={(msg) => { showInfo(msg); reload(); }}
                          onError={(msg) => setError(msg)}
                        >
                          <div className="small mt-3">
                            <Link to={`/Management/Kisi/Kurallar?tab=meslek${fuarId ? `&fuarId=${fuarId}` : ""}`}>{tx("personelDetay.meslekKurallari")}</Link>
                          </div>
                        </KisiMeslekleriKarti>
                      </Col>
                      {/* #284: Mesleki Eğitim'in yüklemesi burada (İncele her yerden). */}
                      <Col lg={6}>
                        {/* #372: kişi bu fuarda 2+ meslek taşıyorsa her mesleğin kendi sertifika kartı; yükleme o mesleğe etiketlenir. */}
                        <MeslekiEgitimKartlari
                          yuvalar={meslekiYuvalar(meslekSatiri)}
                          etiketsiz={etiketsizSertifikalar(meslekSatiri)}
                          tekDoc={documents.meslekiEgitim}
                          tekIstenen={gerekli.includes("meslekiEgitim")}
                          vurgu={vurguKey === "meslekiEgitim"}
                          onIncele={(doc) => openReviewModal("meslekiEgitim", doc)}
                          onYukle={salt ? undefined : (m) => setYukleHedefi({
                            key: "meslekiEgitim", fileTypeId: belgeAnahtariTipId("meslekiEgitim"),
                            meslekId: m?.meslekId, meslekAdi: m?.meslekAdi,
                          })}
                          onEtiketle={salt ? undefined : sertifikaEtiketle}
                        />
                      </Col>
                    </Row>
                    {(meslekIstenen.some((k) => k !== "meslekiEgitim") || meslekDiger.length > 0) && (
                      <Card className="mb-3">
                        <CardHeader className="bg-white border-bottom">
                          <h5 className="mb-0"><Briefcase size={18} className="me-2 text-primary" />{tx("personelDetay.meslekBelgeleri")}</h5>
                        </CardHeader>
                        <CardBody>
                          <div className="d-flex flex-wrap gap-3">
                            {meslekIstenen.filter((k) => k !== "meslekiEgitim").map((key) => belgeKutusu(key))}
                            {meslekDiger.map((key) => belgeKutusu(key, true))}
                          </div>
                        </CardBody>
                      </Card>
                    )}
                  </>
                )}

                {/* Firma Belgeleri: üst çubuktaki fuarda kişinin görevli olduğu her firmanın belge grupları (FIRMA + İSG). */}
                {belgeAlt === "firma" && (
                  !fuarId ? <div className="text-muted small">{secimYok()}.</div>
                    : firmaBelgeBloklari.length === 0 ? <div className="text-muted small">{tx("personelDetay.buFuardaFirmaBelgesiYok")}</div>
                      : (
                        <Row className="g-3">
                          {firmaBelgeBloklari.map((g) => (
                            <Col xl={firmaBelgeBloklari.length > 1 ? 6 : 8} key={g.firmaId}>
                              <FirmaBelgelerKarti
                                gruplar={g.kisi?.firmaBelgeGruplari || g.belgeGruplari}
                                firmaAdi={g.firmaShortname || g.firmaName || tx("personelDetay.firma", { firmaId: g.firmaId })}
                                firmaId={g.firmaId} fuarId={fuarId}
                              />
                            </Col>
                          ))}
                        </Row>
                      )
                )}
              </TabPane>

              {/* ── Giriş Kartı (#367): kart kararı, üst çubuktaki fuarda firma başına ────────────── */}
              <TabPane tabId="giris">
                <GirisKartiSekmesi
                  person={person} detay={detay} fuarId={fuarId} fuarAdi={fuarAdi}
                  onSayfaIci={({ tab, alt, belge, vurgu }) => {
                    setTab(tab, alt);
                    if (belge && documents[belge]?.fileId != null) openReviewModal(belge, documents[belge]);
                    vurguKoy(vurgu ?? belge ?? null); // #481: setTab çerçeveyi kapattı, atlanan hedefinki konur
                  }}
                  onKartYazdir={() => setKartYazdirAcik(true)}
                />
              </TabPane>

              {/* ── Firmalar (#365 #370): Çalışan | İşveren ───────────────────────────────────── */}
              <TabPane tabId="firmalar">
                <KisiFirmalarSekmesi
                  person={person} personId={personId} detay={detay} fuarId={fuarId} fuarAdi={fuarAdi}
                  reloadToken={reloadToken} readOnly={salt}
                  onDegisti={(msg) => { if (msg) showInfo(msg); reload(); }}
                />
              </TabPane>

              {/* ── Kontroller (#368): kimlik doğrulama · KVKK · KKD · Özel İzin · giriş yasağı ───────── */}
              <TabPane tabId="kimlik">
                <Row className="g-3">
                  <Col lg={6}>
                    {/* #481: `id=belge-karti-kimlik` + kırmızı çerçeve — Kart Yazdır'ın / Giriş Kartı'nın Kimlik doğrulama bağlantısı buraya gelir. */}
                    <Card id="belge-karti-kimlik" className={`h-100 mb-0 ${vurguKey === "kimlik" ? VURGU_SINIFI : ""}`}>
                      <CardHeader className="bg-transparent d-flex align-items-center gap-2">
                        <ShieldCheck size={16} className="text-muted" />
                        <span className="fw-semibold">{tx("personelDetay.kimlikDogrulama")}</span>
                        <Button color="primary" size="sm" outline className="ms-auto" disabled={salt} onClick={() => setKimlikModal(true)}>
                          {/* WAS (until #471): {tx("personelDetay.degerlendir")} */}
                          {person.kimlikDogrulama?.durum === 1 ? tx("personelDetay.dogrulamayiGuncelle") : tx("personelDetay.kimligiDogrula")}
                        </Button>
                      </CardHeader>
                      <CardBody>
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <KimlikBadge durum={person.kimlikDogrulama?.durum ?? 0} />
                          {/* 2026-09-17 (backend #54): fuar kuralı değil, her fuarda kart için zorunlu;
                              `kimlikDogrulamaZorunlu` hep true döner. WAS (until #475): "Özel İzin bu şartı da kaldırır" — #474'ten beri
                              kimliği doğrulanmamış kişiye Özel İzin verilmez ve eski bir izin kimlik yerine geçmez. */}
                          <Badge color="danger" className="fw-normal">{tx("personelDetay.kartIcinZorunlu")}</Badge>
                        </div>
                        <div className="small text-muted">
                          {person.kimlikDogrulama?.tarih
                            ? <>{tx("personelDetay.dogrulayan")}{" "}{person.kimlikDogrulama.dogrulayanAdi ?? "—"} · {new Date(person.kimlikDogrulama.tarih).toLocaleString(currentLocaleTag())}</>
                            : tx("personelDetay.henuzDegerlendirilmedi")}
                        </div>
                        {person.kimlikDogrulama?.aciklama && (
                          <div className="small fst-italic mt-1">"{person.kimlikDogrulama.aciklama}"</div>
                        )}
                        {/* #734: the uploaded passport / ID image sits here, next to the identity check (was under İSG Belgeleri › Meslek).
                            Labelled Pasaport for a foreign person (uyrukId 2), as on the Kişi Listesi card; its decision is in the Kimlik Doğrula window (#719). */}
                        {kimlikBelgesiVar && (
                          <div className="d-flex mt-3">
                            {belgeKutusu(
                              KIMLIK_BELGESI, !gerekli.includes(KIMLIK_BELGESI),
                              Number(person.uyrukId) === 2 ? tx("personelDetay.pasaport") : null,
                            )}
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>

                  {/* KVKK (#376) — Dijital Onay + Islak İmzalı Belge. `id=belge-karti-kvkk`: Kişi Listesi'nin gri KVKK karesi buraya gelir (#273). */}
                  <Col lg={6}>
                    <KvkkKarti
                      personId={personId} person={person} kvkkBelge={kvkkBelge} salt={salt} kvkkIsi={kvkkIsi} vurgu={vurguKey === "kvkk"}
                      sablon={sablonlar[BELGE_SABLON_TIPI.kvkk]}
                      onIncele={() => openReviewModal("kvkk", kvkkBelge)} onOnayla={handleKvkkOnayla} onYukle={handleKvkkYukle}
                      onStatus={handleKvkkStatus}
                      onChanged={(msg) => { if (msg) showInfo(msg); reload(); }} onError={(msg) => setError(msg)}
                    />
                  </Col>

                  {/* KKD (#374): üst çubuktaki fuar için kalem kalem işaretleme */}
                  <Col lg={6}>
                    <KkdKarti
                      personId={personId} fuarId={fuarId} fuarAdi={fuarAdi} reloadToken={reloadToken} vurgu={vurguKey === "kkd"}
                      onChanged={(msg) => { if (msg) showInfo(msg); reload(); }} onError={(msg) => setError(msg)}
                    />
                  </Col>

                  {/* ── Özel İzin ─────────────────────────────────────────────── */}
                  <Col lg={6}>
                    <Card className="h-100 mb-0 border border-warning border-opacity-50">
                      <CardHeader className="bg-transparent d-flex align-items-center gap-2">
                        <KeyRound size={16} className="text-warning" />
                        <span className="fw-semibold">{tx("personelDetay.ozelIzin")}</span>
                        {/* İzin fuar başınadır; fuar üst çubuktaki, bu yüzden adı yazılır. */}
                        {fuarId && <Badge color="light" className="text-body border fw-normal">{fuarAdi}</Badge>}
                        {fuarId && (
                          // #475: izin yokken ve kimlik doğrulanmamışken verilecek bir şey yok; izin varsa düğme açık kalır (Geri Al için).
                          <Button color="warning" size="sm" outline className="ms-auto" disabled={salt || (!permit && !kimlikTamam)} onClick={() => setPermitModal(true)}>
                            {permit ? tx("personelDetay.duzenleGeriAl") : tx("personelDetay.izinVer")}
                          </Button>
                        )}
                      </CardHeader>
                      <CardBody>
                        {!fuarId ? (
                          <div className="text-muted small">{secimYok()}.</div>
                        ) : (
                          <>
                            {/* #475: kimliği doğrulanmamış kişiye izin verilmez; doğrulama bu kartın yanındaki Kimlik doğrulama kartıyla aynı pencereyi açar. */}
                            {!kimlikTamam && (
                              <Alert fade={false} color="warning" className="small py-2 mb-3 d-flex align-items-center gap-2 flex-wrap">
                                <IdCard size={16} className="flex-shrink-0" />
                                <span>{tx("personelDetay.onceKimligiDogrulayin")}</span>
                                <Button color="warning" size="sm" outline className="ms-auto" disabled={salt} onClick={() => setKimlikModal(true)}>
                                  {tx("personelDetay.kimligiDogrula")}
                                </Button>
                              </Alert>
                            )}
                            {permit ? (
                              <>
                                <Badge color="warning" className="mb-2">{izinTipiEtiketi(permit)}</Badge>
                                {/* WAS (until #475): <div className="small">{permit.typeString ?? permit.permitTypeString ?? "—"}</div> — boş Açıklama artık NULL saklanıyor (etiket tipin adı). */}
                                {(permit.typeString ?? permit.permitTypeString)?.trim() && (
                                  <div className="small">{permit.typeString ?? permit.permitTypeString}</div>
                                )}
                                {aktifIzinSatiri && (
                                  <div className="small text-muted mt-1">{izinVerenYaz(aktifIzinSatiri)}</div>
                                )}
                              </>
                            ) : (
                              <div className="text-muted small">{tx("personelDetay.buKisininBuFuardaOzel")}</div>
                            )}
                            {iptalIzinleri.length > 0 && (
                              <div className="mt-3 pt-3 border-top">
                                <div className="small text-muted fw-semibold mb-2">{tx("personelDetay.gecmis")}</div>
                                <div className="vstack gap-3">
                                  {iptalIzinleri.map((satir) => <OzelIzinGecmisSatiri key={satir.id} satir={satir} />)}
                                </div>
                              </div>
                            )}
                            <div className="small d-flex gap-2 mt-3">
                              <AlertTriangle size={16} className="flex-shrink-0 text-warning" />
                              <span>{tx("personelDetay.verilirse")}{" "}<strong>{tx("personelDetay.kvkkVeKimlikDisindaHicbirBelge")}</strong>{" "}{tx("personelDetay.istenmez")}</span>
                            </div>
                          </>
                        )}
                      </CardBody>
                    </Card>
                  </Col>

                  {/* Giriş yasağı (#286): her fuarda geçerli, nota bağlı */}
                  <Col lg={6}>
                    <YasakKarti
                      person={person}
                      onChanged={(msg) => { if (msg) showInfo(msg); reload(); }} onError={(msg) => setError(msg)}
                    />
                  </Col>
                </Row>
              </TabPane>

              {/* ── Kullanıcılar (#380): kişiye bağlı FDS kullanıcıları ───────────────────────── */}
              <TabPane tabId="kullanicilar">
                <KisiKullanicilarSekmesi
                  personId={personId} salt={salt} reloadToken={reloadToken}
                  kisi={{ ad: person?.name, soyad: person?.surname, telefon: person?.phone, eposta: person?.email }}
                  onChanged={(msg) => { if (msg) showInfo(msg); reload(); }} onError={(msg) => setError(msg)}
                />
              </TabPane>
            </TabContent>
          </>
        )}
      </Container>

      {/* ── Belge inceleme modalı ───────────────────────────────────────────────── */}
      <Modal isOpen={reviewModal.isOpen} toggle={closeReviewModal}>
        <ModalHeader toggle={closeReviewModal}>{belgeMeta(reviewModal.docKey).label}</ModalHeader>
        <ModalBody>
          {reviewModal.doc && (
            <>
              <div className="mb-2">{statusBadge(reviewModal.doc.status)}</div>
              {paylasimliMi(reviewModal.doc) && (
                <Alert fade={false} color="info" className="small py-2">
                  {tx("personelDetay.firmaninPaylasimliBelgesiKararYalnizca", { belgeVaryantAdi: belgeVaryantAdi(reviewModal.doc.fileTypeId) })}
                  <strong>{" "}{tx("personelDetay.buCalisan")}</strong>{" "}{tx("personelDetay.icinGecerliBelgeninTamami")}
                  <Link to={`/Management/Firmalar/Profil/${reviewModal.doc.paylasimliBelgeFirmaId}?tab=belgeler${fuarId ? `&fuarId=${fuarId}` : ""}`}>
                    {tx("personelDetay.firmaninBelgeleriSayfasinda")}
                  </Link>{" "}{tx("personelDetay.gorulur")}
                </Alert>
              )}
              <div className="small text-muted mb-1">{tx("personelDetay.dosya")}{" "}{reviewModal.doc.fileName ?? "—"}</div>
              <div className="small text-muted mb-1">{tx("personelDetay.sonKullanma")}{" "}{reviewModal.doc.expiryDate ?? "—"}</div>
              {reviewModal.doc.expired && <div className="small text-warning mb-1">{tx("personelDetay.suresiDolmus2")}</div>}
              {reviewModal.doc.rejectReason && (
                <div className="small text-danger mb-1">{tx("personelDetay.mevcutRedGerekcesi")}{" "}{reviewModal.doc.rejectReason}</div>
              )}
              {/* 2026-09-03: yüklemeler artık GERÇEK ve dosyalar kimlik doğrulamalı iki
                  uçtan servis ediliyor. Ama BUGÜN neredeyse her belge eski PHP `repo/`
                  ağacında (73.633 bağın 73.633'ü) ve o uç "eski sistemde saklanıyor"
                  diyor — bu bir hata değil, varsayılan durum. KisiDosyaLink bunu ayırıyor. */}
              <div className="mb-2">
                <KisiDosyaLink
                  personId={personId}
                  fileId={reviewModal.doc.fileId}
                  label={tx("personelDetay.belgeyiAc")}
                  color="light"
                />
              </div>
              {/* #268: Hizmet Dökümü'nün kapsadığı ay (yalnızca bilgi — kartı engellemez). Onay formu aşağıda, belge henüz onaylı değilse. */}
              {paylasimliMi(reviewModal.doc) && reviewModal.doc.fileTypeId === BELGE_TIP.SGK_HIZMET_DOKUMU && reviewModal.doc.belgeDonemi && (
                <div className="small text-muted mb-1">
                  {tx("components:paylasimliBelgeler.donem", { v: donemYaz(reviewModal.doc.belgeDonemi) })}
                  {reviewModal.doc.belgeDonemiEski && (
                    <Badge color="warning" className="ms-2 fw-normal">
                      {tx("components:paylasimliBelgeler.ayEski", { length: reviewModal.doc.belgeDonemiAyFarki })}
                    </Badge>
                  )}
                </div>
              )}
              {/* #297: paylaşımlı belgenin tarihi (firma tarihsiz yükler) ve Hizmet Dökümü'nün ayı belgeye yazılır, belgedeki herkes için geçer. */}
              {!rejectMode && paylasimliMi(reviewModal.doc) && !resmenOnayli(reviewModal.doc) && (
                <div className="mt-3">
                  <PaylasimliOnayAlanlari
                    belge={reviewModal.doc} tarih={gecerlilik} donem={donem} disabled={reviewing}
                    onTarih={setGecerlilik} onDonem={setDonem}
                  />
                </div>
              )}
              {/* #297: belgenin ne zamana kadar sayılacağını onaylayan belirler (paylaşımlı belgede karar ayrı uçta). */}
              {kaldirMode && (
                <Alert fade={false} color="warning" className="small py-2 mt-3 mb-0">{tx("personelDetay.kimlikBelgesiKaldirOnayMetni")}</Alert>
              )}
              {kaldirHata && <Alert fade={false} color="danger" className="small py-2 mt-3 mb-0">{kaldirHata}</Alert>}
              {kimlikBelgesiKimlikPenceresinde && !kaldirMode && (
                <KimlikBelgesiYonlendirme onAc={() => { closeReviewModal(); setKimlikModal(true); }} />
              )}
              {!rejectMode && !kaldirMode && !kimlikBelgesiKimlikPenceresinde && !paylasimliMi(reviewModal.doc) && !resmenOnayli(reviewModal.doc) && (
                <div className="mt-3">
                  <Label className="small mb-1">{tx("personelDetay.gecerlilikTarihi")}</Label>
                  <TarihGirdisi min={bugunYmd()} value={gecerlilik} onChange={setGecerlilik} />
                </div>
              )}
              {rejectMode && (
                <div className="mt-3">
                  <Label className="small">{tx("personelDetay.redGerekcesi")}</Label>
                  <Input
                    type="textarea" rows={3} value={rejectReason}
                    onChange={(e) => setRejectReason(e.target.value)}
                    placeholder={tx("personelDetay.ornBelgeSuresiDolmusGuncelini")}
                  />
                </div>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          {kaldirMode ? (
            <>
              <Button color="secondary" disabled={reviewing} onClick={() => { setKaldirMode(false); setKaldirHata(null); }}>{tx("personelDetay.vazgec")}</Button>
              <Button color="danger" disabled={reviewing} onClick={handleKimlikBelgesiKaldir}>
                {reviewing ? <Spinner size="sm" /> : tx("personelDetay.kimlikBelgesiniKaldirOnayla")}
              </Button>
            </>
          ) : !rejectMode ? (
            <>
              <Button color="secondary" onClick={closeReviewModal}>{tx("common:kapat")}</Button>
              {/* #700: kimlik / pasaport görseli için doğrudan Kaldır — Taşı → Havuza al → sil dolambacı gerekmez. */}
              {reviewModal.docKey === "kimlikFotografi" && !salt && (
                <Button color="danger" outline disabled={reviewing} onClick={() => setKaldirMode(true)}>
                  <Trash2 size={14} className="me-1" />{tx("personelDetay.kimlikBelgesiniKaldir")}
                </Button>
              )}
              {!paylasimliMi(reviewModal.doc) && (
                <>
                  <Button color="light" onClick={() => { setTasima({ mod: "tasi", key: reviewModal.docKey }); closeReviewModal(); }}>
                    {tx("personelDetay.tasi")}
                  </Button>
                  <Button color="light" onClick={() => { setTasima({ mod: "havuza", key: reviewModal.docKey }); closeReviewModal(); }}>
                    {tx("personelDetay.havuzaAl")}
                  </Button>
                </>
              )}
              {!kimlikBelgesiKimlikPenceresinde && (
                <>
                  {reviewModal.doc?.status !== 0 && (
                    <Button color="warning" outline disabled={reviewing} onClick={() => handleReview(0)}>
                      {reviewing ? <Spinner size="sm" /> : <><RotateCcw size={14} className="me-1" />{tx("personelDetay.beklemedeYeAl")}</>}
                    </Button>
                  )}
                  <Button color="danger" outline disabled={reviewing} onClick={() => setRejectMode(true)}>
                    <XCircle size={14} className="me-1" />{tx("personelDetay.reddet")}
                  </Button>
                  <Button
                    color="success" disabled={reviewing || resmenOnayli(reviewModal.doc) || !onayTarihiTamam}
                    onClick={() => handleReview(1)}
                  >
                    {reviewing ? <Spinner size="sm" /> : <><CheckCircle2 size={14} className="me-1" />{tx("personelDetay.onayla")}</>}
                  </Button>
                </>
              )}
            </>
          ) : (
            <>
              <Button color="secondary" onClick={() => setRejectMode(false)}>{tx("personelDetay.vazgec")}</Button>
              <Button
                color="danger" disabled={!rejectReason.trim() || reviewing}
                onClick={() => handleReview(2, rejectReason.trim())}
              >
                {reviewing ? <Spinner size="sm" /> : tx("personelDetay.reddiOnayla")}
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>

      {varyantSlot && person && (
        <BelgeVaryantModal
          slot={varyantSlot} personId={personId} personAd={adSoyad}
          firmaId={belgeFirmaId} fuarId={fuarId} staff
          onClose={() => setVaryantSlot(null)}
          onDone={(msg) => { setVaryantSlot(null); showInfo(msg); reload(); }}
        />
      )}

      {yukleHedefi && person && (
        <BelgeYukleModal
          personId={personId} personAd={adSoyad}
          belgeAdi={`${belgeMeta(yukleHedefi.key).label}${yukleHedefi.meslekAdi ? ` — ${yukleHedefi.meslekAdi}` : ""}`}
          fileTypeId={yukleHedefi.fileTypeId} fuarId={fuarId} meslekId={yukleHedefi.meslekId}
          onClose={() => setYukleHedefi(null)}
          onDone={(msg) => { setYukleHedefi(null); showInfo(msg); reload(); }}
        />
      )}

      {tasima && person && (
        <BelgeTasimaModal
          mod={tasima.mod} personId={personId} kisiAd={adSoyad} firmaId={belgeFirmaId} staff
          doc={documents[tasima.key]}
          belgeAdi={`${belgeMeta(tasima.key).label}${
            belgeVaryantAdi(documents[tasima.key]?.fileTypeId) ? ` — ${belgeVaryantAdi(documents[tasima.key].fileTypeId)}` : ""}`}
          onClose={() => setTasima(null)}
          onDone={(sonuc) => {
            setTasima(null);
            showInfo(tasimaMesaji(sonuc, { havuza: tasima.mod === "havuza" }));
            reload();
          }}
        />
      )}

      {kimlikModal && person && (
        <KimlikDogrulamaModal
          person={person}
          fuarAdi={fuarId ? fuarAdi : null}
          fuarLogoUrl={fuarlar.find((f) => Number(f.id) === Number(fuarId))?.logoUrl ?? null}
          firmaFiltreId={detay?.kartFirmaId ?? null}
          onClose={() => setKimlikModal(false)}
          onSaved={(_, res) => {
            setKimlikModal(false);
            showInfo(tx("personelDetay.kimlikDogrulama2", { adSoyad, v: res?.durumAdi ?? KIMLIK_DURUM[Number(res?.durum)]?.label ?? "" }));
            reload();
          }}
          onFotoDegisti={reload}
        />
      )}

      {permitModal && person && fuarId && (
        <OzelIzinModal
          personId={personId}
          fuarId={fuarId}
          mevcut={permit}
          kimlikTamam={kimlikTamam}
          onKimlikDogrula={() => { setPermitModal(false); setKimlikModal(true); }}
          onClose={() => setPermitModal(false)}
          onSaved={(msg) => { setPermitModal(false); showInfo(msg); reload(); }}
          onKimlikDegisti={reload}
        />
      )}

      {/* Kart Yazdır (#128/#278): Giriş Kartı sekmesinden; fuarda görevli değilse "Fuara Eşle" Firmalar sekmesine götürür. */}
      {kartYazdirAcik && person && fuarId && (
        <KartYazdirModal
          person={person} fuarId={fuarId} fuarAdi={fuarAdi} baslangicFirmaId={detay?.kartFirmaId ?? null}
          fuarLogoUrl={fuarlar.find((f) => Number(f.id) === Number(fuarId))?.logoUrl ?? null}
          onClose={() => { setKartYazdirAcik(false); reload(); }}
          onFuaraEsle={() => { setKartYazdirAcik(false); setTab("firmalar"); }}
        />
      )}
    </div>
  );
}

// WAS (until #466): function MeslekKarti({ person, mesleks, firmalar, fuarId, varsayilanFirmaId, salt, onSaved, onError }) — the fair x firma
// hire-based meslek editor (PATCH /{personId}/meslek with fuarId + firmaId, the "görev firma" select, the FUAR/KISI source badge, the
// read-only state without a fair). Meslekler belong to the person now: Components/Kisi/KisiMeslekleriKarti.jsx.

// WAS (until #471): function KimlikModal({ personId, adSoyad, onClose, onSaved }) — this page's own Kimlik Doğrula modal (3-row
// textarea + a free-text "Dayanak Dosya ID (varsa)" input, no upload, no künye strip, no type). Kişi Listesi's
// Components/Kisi/KimlikDogrulamaModal is the one modal now (#470 / #471).

/** #296: iptal edilmiş bir Özel İzin — tipi, vereni, ne zaman ve neden kapandığı. */
function OzelIzinGecmisSatiri({ satir }) {
  const otomatik = satir.iptalSebebi === OZEL_IZIN_IPTAL_SEBEBI.BELGELER_TAMAMLANDI;
  const Icon = otomatik ? CheckCircle2 : XCircle;
  return (
    <div className="small">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <Badge color="light" className="text-muted">{izinTipiEtiketi(satir)}</Badge>
        {satir.typeString?.trim() && <span>{satir.typeString}</span>}
      </div>
      <div className="text-muted mt-1">{izinVerenYaz(satir)}</div>
      <div
        // Bu temada `success` gri, `secondary` yeşil (bkz. .btn-green notu): otomatik iptal olumlu bir sonuç → yeşil.
        className={`d-flex align-items-center gap-1 mt-1 ${otomatik ? "text-secondary" : "text-muted"}`}
        title={satir.iptalTarihi ? new Date(satir.iptalTarihi).toLocaleString(currentLocaleTag()) : undefined}
      >
        <Icon size={12} className="flex-shrink-0" />{izinIptalYazisi(satir)}
      </div>
    </div>
  );
}

// WAS (until #475): function OzelIzinModal({ personId, fuarId, mevcut, onClose, onSaved }) — the Özel İzin modal lived in this file; it is
// Components/Kisi/OzelIzinModal.jsx now (unverified person: İzni Ver closed, only the three new reasons).
